import createHttp from '@/config/http';
import type { IResponseFetch, ResponseMetaData } from '@/types/service';

const http = createHttp(import.meta.env.VITE_PATIENT_URL);

// Diagnosis Code Types
export interface DiagnosisCode {
	ta_diagnosiscodeid: string;
	ta_name: string;
}

// Application Code Types
export interface ApplicationCode {
	ta_applicationcodesid: string;
	ta_name: string;
}

// ========== DIAGNOSIS CODES ==========
export const getDiagnosisCodes = async (
	page = 1,
	limit = 50,
	search = '',
	sort = '',
): Promise<{
	items: DiagnosisCode[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<IResponseFetch<DiagnosisCode>>(
		'/diagnosis/ai',
		{
			params: {
				page,
				limit,
				search,
				// sort,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

// ========== APPLICATION CODES ==========
export const getApplicationCodes = async (
	page = 1,
	limit = 50,
	search = '',
	sort = '',
): Promise<{
	items: ApplicationCode[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<IResponseFetch<ApplicationCode>>(
		'/applications/ai',
		{
			params: {
				page,
				limit,
				search,
				// sort,
			},
		},
	);
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

export const createApplicationCode = async (
	payload: { ta_name: string },
): Promise<ApplicationCode> => {
	const response = await http.post<{ data: ApplicationCode }>(
		'/applications/',
		payload,
	);
	return response.data.data;
};

export const createDiagnosisCode = async (
	payload: { ta_name: string },
): Promise<DiagnosisCode> => {
	const response = await http.post<{ data: DiagnosisCode }>(
		'/diagnosis/',
		payload,
	);
	return response.data.data;
};

